import React from 'react';

import { InfoLabel, Label, WarningLabel } from '@eika/label';

import { useConfig } from '../../defaultConfig';
import type { AccountBalance, AccountOwner } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { getRelevantOwner } from '../../utils/mapper/accountSorter';
import { isLoanArrear } from './loanUtils';

interface LoanLabelProps {
    balance: AccountBalance;
    owners: AccountOwner[];
}

export const LoanLabels = ({ balance, owners }: LoanLabelProps) => {
    const { featureToggles } = useConfig();
    const translated = useTranslation();
    const labels: ReturnType<typeof Label>[] = [];

    const relevantOwner = getRelevantOwner(owners);

    if (relevantOwner) {
        labels.push(<InfoLabel key="account_owner" text={relevantOwner} size="small" />);
    }
    if (featureToggles.enableLoanArrears && isLoanArrear(balance)) {
        labels.push(<WarningLabel key="loan_arrears" text={translated.loans.arrearsLabel} size="small" />);
    }
    if (labels.length > 0) {
        return <div>{labels}</div>;
    }
    return <></>;
};
